import * as Axios from 'axios';
import * as AxiosApi from './clients/axios';
import * as FetchApi from './clients/fetch';
import OpenApiSpecification from './openapi_deref.json';
export { OpenApiSpecification, AxiosApi, Axios, FetchApi };
